module.exports = __webpack_public_path__ + "static/media/full-logo-white.f2f860de.png";